module.exports = __webpack_public_path__ + "img/文字_A级赛事@3x.057c2bf4.png";